module.exports = __webpack_public_path__ + "img/bmw.7321360a.png";